import { regionStore } from '../data/regionStore.js';
import { nodeStore } from '../data/nodeStore.js';
import { veinStore } from '../data/veinStore.js';
import { configStore } from '../data/configStore.js';
import { AnalysisResultBuilder } from './resultBuilder.js';

class GeoAnalyzer {
  constructor() {
    this.initialized = false;
  }

  async init() {
    if (this.initialized) return;

    await Promise.all([
      regionStore.init(),
      nodeStore.init(),
      veinStore.init(),
      configStore.init()
    ]);

    this.initialized = true;
  }

  async analyze(lat, lng) {
    if (!this.initialized) {
      await this.init();
    }

    const lngLat = [lng, lat];
    const builder = new AnalysisResultBuilder(lat, lng);

    const subzone = regionStore.findSubzoneForPoint(lngLat);
    const planningArea = regionStore.findPlanningAreaForPoint(lngLat);
    builder.setRegionMatch(subzone, planningArea);

    const fengShuiConfig = configStore.findFengShuiConfig(
      subzone?.nameZh,
      planningArea?.nameZh
    );
    builder.setFengShuiProps(
      fengShuiConfig || subzone?.fengShuiProps || planningArea?.fengShuiProps || null
    );

    const nearestNode = nodeStore.findNearestNode(lngLat);
    builder.setNearestNode(nearestNode);

    const nodesInRange = nodeStore.findNodesInRange(lngLat);
    builder.setNodesInRange(nodesInRange);

    const nearestVein = veinStore.findNearestVein(lngLat);
    builder.setNearestVein(nearestVein);

    return builder.build();
  }

  async quickAnalyze(lat, lng) {
    if (!this.initialized) {
      await this.init();
    }

    const lngLat = [lng, lat];
    const subzone = regionStore.findSubzoneForPoint(lngLat);
    const nearestNode = nodeStore.findNearestNode(lngLat);

    return {
      selectedPoint: { lat, lng },
      matchedRegion: subzone?.nameZh || '未知区域',
      nearestNode: nearestNode?.node?.nameZh || '无',
      distance: nearestNode?.distance || 0
    };
  }
}

export const geoAnalyzer = new GeoAnalyzer();
